import axios from 'axios';
import { resolveApiBase } from './apiOrigin';

const base = resolveApiBase(process.env.REACT_APP_BACKEND_URL, process.env.REACT_APP_API_MODE, window.location.origin);
export const api = axios.create({ baseURL: base, withCredentials: true });
let refreshing;
export const errorText = (error) => {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => e.msg).join(' · ');
  if (error.code === 'ERR_NETWORK') return 'Sunucuya bağlanılamadı. Bu bir şifre hatası değildir; bağlantınızı kontrol edip yeniden deneyin.';
  if (error.response?.status >= 500) return 'Giriş hizmeti şu an yanıt veremiyor. Lütfen biraz sonra tekrar deneyin.';
  return error.message || 'İşlem tamamlanamadı. Tekrar deneyin.';
};
const refresh = () => {
  if (!refreshing) refreshing = axios.post(`${base}/auth/refresh`, {}, { withCredentials: true }).finally(() => { refreshing = null; });
  return refreshing;
};
api.interceptors.response.use(r => r, async error => {
  const config = error.config;
  if (error.response?.status === 401 && config && !config.skipAuthRefresh && !config.signal?.aborted && !config.retried && !config.url.includes('/auth/login')) {
    config.retried = true;
    try { await refresh(); return api(config); }
    catch { if (!config.silentAuth && !config.signal?.aborted) window.dispatchEvent(new Event('clinic-session-expired')); }
  }
  return Promise.reject(error);
});

export async function aiRequest(path, body, onStatus, signal) {
  const request = () => fetch(`${base}${path}`, {
    method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body), signal,
  });
  let response = await request();
  if (response.status === 401) {
    try { await refresh(); response = await request(); }
    catch { window.dispatchEvent(new Event('clinic-session-expired')); throw new Error('Oturumunuz sona erdi.'); }
  }
  if (!response.ok) {
    const data = await response.json();
    throw new Error(typeof data.detail === 'string' ? data.detail : 'Bilgileri kontrol edip tekrar deneyin.');
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const chunks = buffer.split('\n\n');
    buffer = chunks.pop();
    for (const chunk of chunks) {
      if (!chunk.startsWith('data: ')) continue;
      const event = JSON.parse(chunk.slice(6));
      if (event.type === 'error') throw new Error(event.message);
      if (event.type === 'result') return event.data;
      onStatus?.(event.message);
    }
  }
  throw new Error('Bağlantı kesildi. Yeniden deneyin.');
}